import script from "./RouteLoadingScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteLoadingScreen.vue?vue&type=script&setup=true&lang=js"

import "./RouteLoadingScreen.vue?vue&type=style&index=0&id=189d0d88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-189d0d88"]])

export default __exports__